<template>
    <modal :show="show" class="modal-add-unit">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Add Unit</modal-header>
        </div>
        <div v-if="creativeUnitType !== 'after-effects'" class="form-group">
          <label for="master" class="control-label">master</label>
          <select class="form-control" id="master" v-model="choices.masterChosen">
            <option v-for="(value, key) in this.masters" :key="key" >{{ value }}</option>
          </select>
        </div>
      <div v-else class="form-group">
        <label for="composition" class="control-label">composition</label>
        <select class="form-control" id="composition" v-model="choices.composition">
          <option v-for="(value, key) in this.compositions" :key="key" :value="value" >{{ value }}</option>
        </select>
      </div>
        <div class="form-group">
          <label for="locale">locale</label>
          <input type="text" class="form-control" id="locale" v-model="choices.locale">
        </div>
        <div v-if="creativeUnitType !== 'after-effects'" class="form-group">
          <label for="width">width</label>
          <input type="text" class="form-control" id="width" v-model="choices.width">
        </div>
        <div v-if="creativeUnitType !== 'after-effects'" class="form-group">
          <label for="height">height</label>
          <input type="text" class="form-control" id="height" v-model="choices.height">
        </div>
        <div class="form-group" v-if="creativeUnitType === 'html-video'">
          <label for="render_video_duration">Video duration</label>
          <input type="number" class="form-control" id="render_video_duration" v-model="choices.render_video_duration">
          <br/>
          <small>
            Define the number of seconds for the video duration according with the banner animation duration. (Use period to define decimal values. Ex: 7.25)
          </small>
        </div>
        <div class="form-group" v-if="creativeUnitType === 'html-video'">
          <label for="render_video_fps" class="control-label">Video FPS</label>
          <select id="render_video_fps" name="render_video_fps" class="form-control" v-model="choices.render_video_fps">
            <option v-for="(value, key) in fpsOptions" :key="key" :value="key">{{ value }}</option>
          </select>
          <br/>
          <small>
            A higher value will result in a smoother video but will also have a larger filesize.
          </small>
        </div>
        <div class="form-group" v-if="creativeUnitType === 'html-video'">
          <label for="render_video_format" class="control-label">Video Format</label>
          <select id="render_video_format" name="render_video_format" class="form-control" v-model="choices.render_video_format">
            <option v-for="(value, key) in videoFormats" :key="key" :value="key">{{ value }}</option>
          </select>
        </div>
        <div slot="modalFooter">
          <modal-footer :closeModal="close" cancelText="Cancel" :confirm="isReady? confirm : noConfirm" confirmText="Create unit" :confirmDisabled="!isReady"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_add_creativeUnit',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String,
    masters: null,
    creativeUnitType: String,
    compositions: null
  },
  data: () => ({
    choices: {
      masterChosen: null,
      locale: null,
      width: null,
      height: null,
      render_video_duration: 8,
      render_video_fps: 15,
      render_video_format: 'mp4',
      composition: null
    }
  }),
  mounted () {
  },
  computed: {
    isReady () {
      // Validations for the html to video units
      if (this.creativeUnitType === 'html-video' && this.isValidNumber(this.choices.render_video_duration, 2) === false) {
        return false
      }
      if (this.creativeUnitType === 'after-effects' && !this.choices.width && !this.choices.height) {
        return true
      }
      if (this.choices.locale === null || this.choices.locale === '' || this.choices.masterChosen === null || this.isValidNumber(this.choices.width) === false || this.isValidNumber(this.choices.height) === false) {
        // return false
      } else {
        return true
      }
    },
    fpsOptions () {
      return {
        12: 12,
        15: 15,
        24: 24,
        29: 29,
        30: 30,
        50: 50,
        60: 60
      }
    },
    videoFormats () {
      return {
        mp4: 'MP4',
        gif: 'GIF'
      }
    }
  },
  methods: {
    confirm () {
      const choices = {...this.choices}
      if (this.creativeUnitType !== 'html-video') {
        delete choices.render_video_duration
        delete choices.render_video_fps
        delete choices.render_video_format
      }
      if (this.creativeUnitType !== 'after-effects') {
        delete choices.composition
      }
      if (this.creativeUnitType === 'after-effects') {
        choices.masterChosen = this.masters[0]
      }

      this.$emit('addUnit', choices)
      this.choices.locale = null
      this.close()
    },
    noConfirm () {
    },
    isValidNumber (inputNumber, min = 0) {
      return inputNumber !== '' && Number(inputNumber) >= min
    }
  }
}

</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-add-unit.vue